import React from "react";
import { useSelector } from "react-redux";
import ConfirmationPanel from "./ConfirmationPanel";
import OrderDetails from "./OrderDetails";
import InKindLogo from "../../../../assets/images/icons/inkind-logo.png";
import InKindPass from "../../../../assets/images/icons/inkind-pass.png";
import "core-js/es/object";
const RightPanel = () => {
  const ikPass = useSelector((state) => state.nav.ikPass);
  const ikPassSingle = useSelector((state) => state.nav.ikPassSingle);
  const company = useSelector((state) => state.company);
  const pageStatus = useSelector((state) => state.nav.pageStatus);
  const cloudinary = `${company.presenter.cloudinary_path}/h_120/`;
  let sister_brands = company?.presenter?.sister_brands
    ? Object.entries(company.presenter.sister_brands)
    : [];
  return (
    <div className="right-panel-col">
      {company.presenter.is_inkind_cash ? (
        <img
          src={InKindLogo}
          className="parent-brand ik-pass-logo"
          alt="Inkind Logo"
        />
      ) : company.presenter.logo_light_wide ? (
        <img
          className={` parent-brand ${
            Object.entries(company.presenter.sister_brands).length > 0
              ? "has-sisters"
              : "only"
          }`}
          src={`${company.presenter.cloudinary_path}/h_280/${
            sister_brands.length
              ? company.presenter.logo_light_wide
              : company.presenter.project_logo_white_path
          }`}
        />
      ) : (
        <div className="group-square-no-img">
          {company.presenter.project_name}
        </div>
      )}

      {sister_brands.length > 0 && (
        <div className="sister-brands-wrap">
          {sister_brands.map((brand, i) =>
            brand[1][0] ? (
              <img
                className="brand"
                src={cloudinary.concat(brand[1][0])}
                alt={brand[0]}
                key={i}
              />
            ) : (
              <div key={i} className="brand-square">
                {brand[1]}
              </div>
            ),
          )}
        </div>
      )}
      {pageStatus === "confirmation" ? (
        <ConfirmationPanel ikPass={!!company.presenter.is_inkind_cash} />
      ) : (
        <OrderDetails
          company={company}
          ikPass={!!company.presenter.is_inkind_cash}
        />
      )}
    </div>
  );
};

export default RightPanel;
